<template>
  <label class="custom-toggle" :class="switchClass">
    <input type="checkbox" v-model="model" @click="clickEvent" @change="changeEvent" />
    <span class="custom-toggle-slider rounded-circle" :data-label-off="offText" :data-label-on="onText">
    </span>
  </label>
</template>
<script>
export default {
  name: "base-switch",
  props: {
    value: [Array, Boolean],
    type: String,
    onText: {
      type: String,
      default: "Yes"
    },
    offText: {
      type: String,
      default: "No"
    }
  },
  computed: {

    switchClass() {
      let baseClass = "custom-toggle-";
      if (this.type) {
        return baseClass + this.type;
      }
      return "";
    },
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  },
  methods: {
    clickEvent(evt) {
      //console.log(this.$attrs);
      //console.log(evt);
      if (this.$attrs.disabled) {
        evt.preventDefault();
      }
    },
    changeEvent(evt) {
      //console.log(this.$attrs);
      //console.log(evt);
      if (!this.$attrs.disabled) {
        this.$emit('change', evt);
      }
    },
    triggerToggle() {
      // console.log(disabled)
      //if (!disabled) {
      this.model = !this.model;
      //}
    }
  }
};
</script>
<style>
/* .custom-toggle-slider {
  border: 1px solid #666666;
}

.rounded-circle {
  border: 1px solid #666666 !important;
}

.custom-toggle-slider:before {
  background-color: #666666 !important;
}

.custom-toggle-slider:after {
  color: #666666;
}

.custom-toggle input:checked + .custom-toggle-slider:before {
  background: red !important;
  transform: translateX(28px);
} 
*/
</style>
